import { render, staticRenderFns } from "./DetailsTarif.vue?vue&type=template&id=5ce4fab2&scoped=true&"
import script from "./DetailsTarif.vue?vue&type=script&lang=js&"
export * from "./DetailsTarif.vue?vue&type=script&lang=js&"
import style0 from "./DetailsTarif.vue?vue&type=style&index=0&id=5ce4fab2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ce4fab2",
  null
  
)

export default component.exports